import {Columns} from 'compob2b-table';
import {translations} from '../../../../environments/translations.ru';


export const CATALOG_FORM: Columns[] = [
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },

  // {
  //   key: 'catalogTreeSynonym',
  //   title: 'Обновить синонимы во всех дочерних разделах',
  //   placeholder: 'Обновить синонимы во всех дочерних разделах',
  //   searchEnabled: false,
  //   defaultValue: false,
  //   formly: true,
  //   grid: false,
  //   type: 'checkbox',
  //   required: false,
  // },

  {
    key: 'parentId',
    title: translations.parent,
    placeholder: translations.parent,
    searchEnabled: true,
    formly: true,
    type: 'catalog-picker',
    templateOptions: {
      label: translations.parent,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header',
      chooseOnlyLastLevel: false,
    },
    width: '100%',
    grid: false
  },
  {
    key: 'syncUid',
    title: translations.syncUid,
    placeholder: translations.syncUid,
    searchEnabled: false,
    formly: true,
    grid: false,
    type: 'input',
    required: false,
    templateOptions: {
      label: translations.syncUid,
      readonly: true
    },
    hideExpression: 'model.editMode === false'
  },
  {
    key: 'htHead',
    title: translations.htHead,
    placeholder: translations.htHead,
    searchEnabled: false,
    formly: true,
    grid: false,
    type: 'input',
    required: false,
  },
  {
    key: 'htDesc',
    title: translations.htDesc,
    placeholder: translations.htDesc,
    searchEnabled: false,
    formly: true,
    grid: false,
    type: 'input',
    required: false,
  },
  {
    key: 'htKeywords',
    title: translations.htKeywords,
    placeholder: translations.htKeywords,
    searchEnabled: false,
    formly: true,
    grid: false,
    type: 'input',
    required: false,
  },
  {
    key: 'content',
    title: translations.content,
    placeholder: translations.content,
    searchEnabled: true,
    formly: true,
    type: 'editor-input',
    width: '100%',
    grid: false
  },
  {
    key: 'channelIDs',
    title: translations.channel,
    placeholder: translations.channel,
    formly: true,
    type: 'multicheckbox',
    grid: true,
    templateOptions: {
      label: translations.channel,
      required: false,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header'
    },
    hideExpression: 'model.level !== 2'
  },
  {
    key: 'pictureInput',
    title: '',
    placeholder: '',
    searchEnabled: false,
    orderEnabled: false,
    picture: true,
    grid: false,
    formly: false,
    type: 'file-upload-input',
    required: true,
    templateOptions:  {

      /**
       * @see FileUploaderOptions in ng2-file-upload/file-upload/file-uploader.class
       */
      fileOptions:   {
        maxFileSize: 5 * 1024 * 1024, // 5Mb
        allowedMimeType: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif']
      },
      label: ''
    }
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    grid: false,
    defaultValue: true,
    type: 'checkbox',
    required: true
  },
  {
    key: 'pos',
    title: translations.position,
    placeholder: translations.position,
    searchEnabled: false,
    formly: true,
    grid: false,
    type: 'input',
    required: false,
    className: 'formly-middle',
    cssClass: { includeHeader: false, name: 'font-small' }
  },
  {
    key: 'action',
    title: translations.htKeywords,
    placeholder: translations.htKeywords,
    searchEnabled: false,
    orderEnabled: false,
    grid: true,
    formly: false,
    type: 'input',
    required: true
  }
];
